module.exports = __webpack_public_path__ + "img/desktop-design.a49054ff.jpg";